import React from "react";

import SectionHeader from "@cayuse/shared-react.components.section-header";

import { useDictionary } from "hooks";

import AttachmentTypesSection from "../AttachmentTypesSection";
import ProjectAttachmentTypesSection from "../ProjectAttachmentTypesSection";

const AttachmentTypesMainView = () => {
    const dictionary = useDictionary("attachmentTypes");

    return (
        <div>
            <SectionHeader header={dictionary.manageAttachmentTypes} />
            <AttachmentTypesSection />
            <ProjectAttachmentTypesSection />
        </div>
    );
};

export default AttachmentTypesMainView;
